export default __webpack_public_path__ + "static/media/book.c714da52.svg";